module.exports = __webpack_public_path__ + "img/C98D7F_3B0B0B_A97667_94433F-256px.322d2b9a.png";